// A fee row is tagged only when the recalculation (not a person) made its pending change.
export const getAutomaticFeeChangeActionType = fee =>
  fee?.isAutomaticChange ? fee.pendingChangesActionType : null;
